import { makeStyles } from '@material-ui/core';
import { CSSProperties } from '@material-ui/core/styles/withStyles';
import { rem } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../../mui-theme';

const baseSummaryLabel: CSSProperties = {
  fontWeight: 'bold',
  textTransform: 'uppercase',
  lineHeight: 1,
  color: themeColor.modalTitle,
};

const headingFontSize: CSSProperties = {
  fontSize: rem(1.7),
  '@media (max-width: 1600px)': {
    fontSize: rem(1.5),
  },
  '@media (max-width: 1366px)': {
    fontSize: rem(1.2),
  },
  '@media (width: 1366px) and (height: 768px)': {
    fontSize: rem(1.2),
  },
  '@media (width: 1600px) and (height: 1200px)': {
    fontSize: rem(1.5),
  },
  '@media (max-width: 1024px)': {
    fontSize: rem(1),
  },
  '@media  (width: 1280px) and (height: 720px)': {
    fontSize: rem(1.2),
  },
  '@media  (width: 1024px) and (height: 768px)': {
    fontSize: rem(1.2),
  },
};

const subheadingFontSize: CSSProperties = {
  fontSize: rem(1.6),
  '@media (max-width: 1600px)': {
    fontSize: rem(1.4),
  },
  '@media (max-width: 1366px)': {
    fontSize: rem(1.1),
  },
  '@media (width: 1366px) and (height: 768px)': {
    fontSize: rem(1.1),
  },
  '@media (width: 1600px) and (height: 1200px)': {
    fontSize: rem(1.4),
  },
  '@media (max-width: 1024px)': {
    fontSize: rem(0.9),
  },
  '@media  (width: 1280px) and (height: 720px)': {
    fontSize: rem(1.1),
  },
  '@media  (width: 1024px) and (height: 768px)': {
    fontSize: rem(1.1),
  },
};

export const couponStyles = makeStyles(() => ({
  summaryLabel: {
    ...baseSummaryLabel,
    ...headingFontSize,
    letterSpacing: 1,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  summaryText: {
    ...subheadingFontSize,
    color: themeColor.subheaderLight,
  },
  outermostGrid: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  couponListContainer: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'hidden',
    height: '96%',
    padding: '0.7320644216691069vw 0px 0.7320644216691069vw 0px',
  },
  couponGroupItem: {
    fontSize: '18px',
    flex: 1,
    maxWidth: '80%',
  },
  couponPagination: {
    height: '10%',
    flexDirection: 'row',
    justifyContent: 'space-around',
    position: 'absolute',
    bottom: 0,
  },
  couponIconContainer: {
    alignSelf: 'center',
    padding: '0px 1.0980966325036603vw 0px 0px',
  },
  couponListBody: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    width: '100%',
  },
  couponListItem: {
    flex: 1,
    alignItems: 'center',
  },
  body: {
    flex: 1,
    padding: '1.953125vh 1.0980966325036603vw 0vh 1.0980966325036603vw',
  },
  footer: {
    minHeight: '10%',
    width: '100%',
  },
  summaryGrid: {
    flex: 1,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    width: '100%',
    textOverflow: 'ellipsis',
  },
  summaryQuantityGrid: {
    overflow: 'unset',
    width: 'fit-content',
  },
}));

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const styles = makeStyles(_theme => ({
  dialogPadding: {
    padding: '1.9vh',
    paddingBottom: '0vh',
    justifyContent: 'flex-start',
  },
  footer: {
    marginTop: 'auto',
  },
  summaryLabel: {
    ...baseSummaryLabel,
    ...headingFontSize,
    letterSpacing: 1,
  },
  summaryText: {
    ...subheadingFontSize,
    lineHeight: 2,
    color: themeColor.subheaderLight,
    marginTop: '1vh',
    fontWeight: 'bold',
    position: 'relative',
    left: '5vw',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    width: 'calc(100% - 5vw)',
    display: 'inline-block',
  },
  rowRelative: {
    position: 'relative',
  },
  promotionSummaryText: {
    ...subheadingFontSize,
    lineHeight: 2,
    color: themeColor.modalTitle,
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  summaryItemContainer: {
    height: '60vh',
    overflowY: 'auto',
  },
  summaryTextContainer: {
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
  paginationContainer: {
    flexGrow: 1,
    width: 'auto',
  },
  promotionLines: {
    fontWeight: 500,
    textTransform: 'uppercase',
    lineHeight: 1,
    color: themeColor.modalTitle,
    marginLeft: '1vw',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    ...subheadingFontSize,
  },
  containerSeparator: {
    width: '36vw',
    height: '0.2vh',
    top: '50%',
    background: themeColor.secondaryLight,
    position: 'absolute',
  },
  promotionLineSeparator: {
    width: '36vw',
    height: '0.2vh',
    marginTop: '2vh',
    marginLeft: '1vh',
    background: themeColor.secondaryLight,
  },
  detailLine: {
    height: 'fit-content',
    position: 'relative',
    left: '5vw',
    color: themeColor.modalTitle,
    fontWeight: 500,
  },
  promotionDescription: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    width: 'calc(100% - 5vw)',
    display: 'inline-block',
  },
  iconStyle: {
    height: '3.5vh',
    width: '3.5vw',
    '@media (max-width: 1600px)': {
      height: '3.7vh',
      width: '3.7vw',
    },
    '@media (width: 1600px) and (height: 1200px)': {
      height: '3.5vh',
      width: '3.5vw',
    },
  },
  iconColor: {
    color: themeColor.subheaderLight,
    fill: themeColor.subheaderLight,
  },
  containerStyle: {
    flexWrap: 'nowrap',
    alignItems: 'center',
    marginTop: '2vh',
  },
  additionalStyle: {
    marginLeft: 'auto',
    alignSelf: 'center',
    paddingTop: '2vh',
    justifyContent: 'flex-end',
  },
  totalMargin: {
    marginLeft: '3vw',
  },
  customMargin: {
    paddingTop: '13vh',
    height: '100%',
    overflow: 'hidden',
  },
}));
